import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as utils from '../../utils';

class Carousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedItemIndex: 0
        };
    }

    stepPage(step) {

        const nextIndex = this.state.selectedItemIndex + step;

        if (nextIndex <= this.props.objects.length - 1 && nextIndex >= 0) {
            this.setState({
                selectedItemIndex: this.state.selectedItemIndex + step
            });
        }
    }

    componentDidMount() {

    }

    render() {
        if (utils.getIsViewportEqual("xs", "sm")) {
            return (
                <div>
                    <div className="d-flex justify-content-between align-items-center mt-3 btn-group border">

                        {/* <div title="Назад" onClick={() => this.stepPage(-1)}>
                            <FontAwesomeIcon icon="angle-left" size="1x" color="#000" />
                        </div> */}

                        <button style={{ maxHeight: "50px", maxWidth: "50px" }} disabled={false} className="btn btn-secondary" title="Назад" onClick={() => this.stepPage(-1)}>
                            <FontAwesomeIcon icon="angle-left" size="sm" color="#fff" />
                        </button>

                        <div>
                            {
                                this.props.objects.length === 0 ? 
                                <strong>Нет данных</strong> :
                                <strong>Запись {this.state.selectedItemIndex + 1} из {this.props.objects.length}</strong>
                            }
                        </div>

                        {/* <div title="Далее" onClick={() => this.stepPage(1)}>
                            <FontAwesomeIcon icon="angle-right" size="1x" color="#000" />
                        </div> */}

                        <button style={{ maxHeight: "50px", maxWidth: "50px" }} className="btn btn-secondary" title="Далее" onClick={() => this.stepPage(1)}>
                            <FontAwesomeIcon icon="angle-right" size="sm" color="#fff" />
                        </button>
                    </div>

                    {
                        this.props.objects[this.state.selectedItemIndex]
                    }

                </div>
            );
        }
        else {
            return (
                <div className="d-flex justify-content-around mt-3 align-items-center">
                    {
                        this.props.objects
                    }
                </div>
            );
        }
    }
}

export default Carousel;